import React, { KeyboardEventHandler, ReactElement, useContext } from "react";
import { ToolbarContext } from "../utils/toolbarContext";
import { ToolbarActionType } from "../utils/toolbarReducer.types";
import { ToolbarListItemProps } from "./toolbar-list-item.types";

export const ToolbarListItem = ({
  children,
  closeOnClick,
  onClick,
  ...rest
}: ToolbarListItemProps): ReactElement => {
  const { dispatch } = useContext(ToolbarContext);

  const _closeAllToolbarDropdowns = (): void => {
    dispatch({
      type: ToolbarActionType.CLOSE_ALL_TOOLBAR_ITEM_DROPDOWNS,
      inProgress: true,
    });
    dispatch({
      type: ToolbarActionType.CLOSE_SHOW_MORE_DROPDOWN,
      inProgress: true,
    });
  };

  const _onClickHandler = (
    event: React.MouseEvent<HTMLLIElement> | React.KeyboardEvent<HTMLLIElement>
  ): void => {
    onClick?.(event);
    if (closeOnClick) {
      _closeAllToolbarDropdowns();
    }
  };

  const _handleToolbarItemKeyPress: KeyboardEventHandler<HTMLLIElement> = (
    event
  ): void => {
    if (event.key === "Enter") {
      _onClickHandler(event);
    }
  };

  return (
    <li
      {...rest}
      onKeyUp={_handleToolbarItemKeyPress}
      onClick={_onClickHandler}
    >
      {children}
    </li>
  );
};

ToolbarListItem.displayName = "ToolbarListItem";
